import React from "react"

function TopNav() {
  return (
    <nav className="text-right px-3 pt-4 max-w-[1110px] mx-auto">
      <a
        href={`https://diningout.cashstar.com/`}
        target="_blank"
        rel="noreferrer"
        className="text-sm text-gold uppercase border border-transparent transition-all hover:border-gold py-1 px-3 ml-1 md:ml-4 md:text-base"
      >
        Buy Now
      </a>
      <a
        href={`https://www.showmybalance.com/`}
        target="_blank"
        rel="noreferrer"
        className="text-sm text-gold uppercase border border-transparent transition-all hover:border-gold py-1 px-3 ml-1 md:ml-4 md:text-base"
      >
        Check Balance
      </a>
    </nav>
  )
}

export default TopNav
